import React from 'react';
import { Box, Typography } from '@mui/material';
import FormattedInfoText from '@/components/common/FormattedInfoText';
import { HELP_TEXT_MAX_LENGTH } from '@shared/help-text';

/** Helper text under every admin field whose value is rendered by FormattedInfoText. */
export const INFO_TEXT_SYNTAX_HINT = 'Börja rader med - för punktlista eller 1. för numrerad lista.';

/**
 * Helper text for a help-text field: the syntax hint plus a counter against
 * the shared limit, identical in both admin editors (AG-283).
 */
export const infoTextHelperText = (text: string | undefined): string =>
  `${INFO_TEXT_SYNTAX_HINT} ${text?.length ?? 0} / ${HELP_TEXT_MAX_LENGTH} tecken`;

interface InfoTextPreviewProps {
  text: string;
}

/**
 * Shows the admin how a help text will look to the farmer, formatted by the
 * same component the control view uses. Renders nothing for blank text.
 */
const InfoTextPreview: React.FC<InfoTextPreviewProps> = ({ text }) => {
  if (!text.trim()) return null;

  return (
    <Box
      data-testid="info-text-preview"
      sx={{ mt: 1, p: 1.5, border: 1, borderColor: 'divider', borderRadius: 1, bgcolor: 'grey.50' }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          display: 'block',
          mb: 0.5
        }}>
        Förhandsvisning
      </Typography>
      <FormattedInfoText text={text} />
    </Box>
  );
};

export default InfoTextPreview;
